import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useSite } from "@/lib/site";

const PageEditor = ({ pageKey, title }) => {
  const { content, refresh } = useSite();
  const [text, setText] = useState(content.pages?.[pageKey]?.content || "");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      await api.put(`/admin/pages/${pageKey}`, { content: text });
      toast.success(`${title} saved`);
      refresh();
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="rounded-2xl border border-ink/10 bg-white p-6" data-testid={`admin-page-${pageKey}`}>
      <h3 className="mb-3 font-display text-xl font-semibold text-ink">{title}</h3>
      <textarea
        data-testid={`admin-page-${pageKey}-editor`}
        rows={10}
        value={text}
        onChange={(e) => setText(e.target.value)}
        className="w-full rounded-xl border border-ink/15 px-4 py-3 text-sm leading-relaxed outline-none focus:border-terra"
      />
      <button
        data-testid={`admin-page-${pageKey}-save`}
        onClick={save}
        disabled={saving}
        className="mt-4 inline-flex items-center gap-2 rounded-full bg-terra px-5 py-2.5 font-outfit text-sm font-semibold text-white hover:bg-terradark disabled:opacity-60"
      >
        {saving && <Loader2 className="h-4 w-4 animate-spin" />} Save {title}
      </button>
    </div>
  );
};

export const PagesTab = () => (
  <div data-testid="admin-tab-pages" className="grid max-w-5xl grid-cols-1 gap-6 lg:grid-cols-2">
    <PageEditor pageKey="terms" title="Terms & Conditions" />
    <PageEditor pageKey="privacy" title="Privacy Policy" />
  </div>
);
